var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgImgLogoKakao = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 56,
  height: 56,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 28,
  r: 28,
  fill: "#FEE500"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M27.995 16C20.267 16 14 20.972 14 27.107c0 3.967 2.618 7.442 6.561 9.415l-1.42 5.104s-.026.238.127.328c.152.09.336.02.336.02.442-.063 5.1-3.358 5.915-3.929.804.116 1.64.175 2.486.175C35.733 38.22 42 33.248 42 27.112 42 20.977 35.723 16 27.995 16Z",
  fill: "#000"
})));

export default SvgImgLogoKakao;